import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

// Dont have an ITR statement
import {
  ITR_skipItrSave_API_CALL,
  ITR_skipItrSave_API_CALL_extrareducer,
} from './itr-journey/api/skip-itr-save';

// Online ITR Journey
import {
  ITR_perfiosOnlineBanking_API_CALL,
  ITR_perfiosOnlineBanking_API_CALL_extrareducer,
} from './itr-journey/api/perfios-online-banking';
import {
  ITR_bsVerifyTxn_API_CALL,
  ITR_bsVerifyTxn_API_CALL_extrareducer,
} from './itr-journey/api/bs-verify-txn';

// Offline ITR Journey
import {
  ITR_s3FileUpload_API_CALL,
  ITR_s3FileUpload_API_CALL_extrareducer,
} from './itr-journey/api/s3-file-upload';
import {
  ITR_saveBsDocUpload_API_CALL,
  ITR_saveBsDocUpload_API_CALL_extrareducer,
} from './itr-journey/api/save-bs-docupload';

import { ITR_updateCurrentScreenReducer } from './itr-journey/functions/update-current-screen';
import { ITR_updatePreviousScreenReducer } from './itr-journey/functions/update-previous-screen';
import { ITR_moveBackConvUIReducer } from './itr-journey/functions/move-back-conv-ui';
import { ITR_flushAPICallsDataReducer } from './itr-journey/functions/flush-api-calls-data';

import initialStateITRJourney from './itr-journey/api/intial-state-itr-journey';
import { ITR_updateAckScreenMsgsReducer } from './itr-journey/functions/update-ack-screen-msgs';
import { ITR_updateJourneyTypeEnumReducer } from './itr-journey/functions/update-journey-type-enum';
import { ITR_updateMonthlyStatementErrReducer } from './itr-journey/functions/update-monthly-stmt-err';
import { ITR_setGlobalOverlayLoaderReducer } from './itr-journey/functions/set-global-overlay-loader';
import { ITR_setItrPasswordReducer } from './itr-journey/functions/set-itr-password';
import { ITR_toggleRightSidebarReducer } from './itr-journey/functions/toggle-right-sidebar';
import { ITR_updateFlowTypeEnumReducer } from './itr-journey/functions/update-flow-type-enum';
import { ITR_updateShowITRWelcomeScreenReducer } from './itr-journey/functions/update-show-welcome-screen';

export const itrJounrneySlice = createSlice({
  name: 'itrJourney',
  initialState: initialStateITRJourney,
  reducers: {
    ...ITR_updateCurrentScreenReducer,
    ...ITR_updatePreviousScreenReducer,
    ...ITR_moveBackConvUIReducer,
    ...ITR_flushAPICallsDataReducer,
    ...ITR_updateAckScreenMsgsReducer,
    ...ITR_updateMonthlyStatementErrReducer,
    ...ITR_setGlobalOverlayLoaderReducer,
    ...ITR_setItrPasswordReducer,
    ...ITR_toggleRightSidebarReducer,
    ...ITR_updateFlowTypeEnumReducer,
    ...ITR_updateJourneyTypeEnumReducer,
    ...ITR_updateShowITRWelcomeScreenReducer,
  },
  extraReducers: {
    ...ITR_perfiosOnlineBanking_API_CALL_extrareducer,
    ...ITR_bsVerifyTxn_API_CALL_extrareducer,
    ...ITR_s3FileUpload_API_CALL_extrareducer,
    ...ITR_saveBsDocUpload_API_CALL_extrareducer,
    ...ITR_skipItrSave_API_CALL_extrareducer,
  },
});

export const {
  ITR_updateCurrentScreen,
  ITR_updatePreviousScreen,
  ITR_moveBackConvUI,
  ITR_flushAPICallsData,
  ITR_setITRJourneyType,
  ITR_updateAckScreenMsgs,
  ITR_updateMonthlyStatementErr,
  ITR_setItrPassword,
  ITR_setGlobalOverlayLoader,
  ITR_toggleRightSidebar,
  ITR_updateFlowTypeEnum,
  ITR_updateJourneyTypeEnum,
  ITR_updateShowITRWelcomeScreen,
} = itrJounrneySlice.actions;

export function useItrJourneyStore() {
  const itrState = useSelector((state) => state.itrJourney);
  const previousScreen = useSelector(
    (state) => state.itrJourney.previousScreen
  );
  const currentScreen = useSelector((state) => state.itrJourney.currentScreen);

  const journeyTypeEnum = useSelector(
    (state) => state.itrJourney.journeyTypeEnum
  );

  const dispatch = useDispatch();
  return {
    // TODO: State returns here
    itrState,
    previousScreen,
    currentScreen,
    journeyTypeEnum,

    // TODO: Write the sync action functions here
    updateScreen: () => dispatch(ITR_updateCurrentScreen()),
    updateCurrentScreen: (screenName) =>
      dispatch(ITR_updateCurrentScreen(screenName)),
    updatePreviousScreen: (screenName) =>
      dispatch(ITR_updatePreviousScreen(screenName)),
    moveBackConvUI: (screenName) => dispatch(ITR_moveBackConvUI(screenName)),
    flushAPICallsData: () => dispatch(ITR_flushAPICallsData()),
    setItrJourneyType: (journeyTypeEnum) =>
      dispatch(ITR_setITRJourneyType(journeyTypeEnum)),
    updateAckScreenMsgs: (payload) =>
      dispatch(ITR_updateAckScreenMsgs(payload)),

    updateMonthlyStatementErr: (payload) =>
      dispatch(ITR_updateMonthlyStatementErr(payload)),
    setGlobalOverlayLoader: (payload) =>
      dispatch(ITR_setGlobalOverlayLoader(payload)),
    // DOCS: @Manish's Suspend Flow Intervents
    updateFlowTypeEnum: (payload) => dispatch(ITR_updateFlowTypeEnum(payload)),
    updateITRJourneyTypeEnum: (payload) =>
      dispatch(ITR_updateJourneyTypeEnum(payload)),
    updateShowITRWelcomeScreen: (payload) =>
      dispatch(ITR_updateShowITRWelcomeScreen(payload)),

    // TODO: API calls or Async stuff here
    perfiosOnlineBanking_API_CALL: (payload) =>
      dispatch(ITR_perfiosOnlineBanking_API_CALL(payload)),
    itrVerifyTxn_API_CALL: (payload) =>
      dispatch(ITR_bsVerifyTxn_API_CALL(payload)),
    s3FileUpload_API_CALL: (payload) =>
      dispatch(ITR_s3FileUpload_API_CALL(payload)),
    saveBsDocUpload_API_CALL: (payload) =>
      dispatch(ITR_saveBsDocUpload_API_CALL(payload)),
    ITR_skipItrSave_API_CALL: (payload) =>
      dispatch(ITR_skipItrSave_API_CALL(payload)),
    setItrPassword: (payload) => dispatch(ITR_setItrPassword(payload)),
    toggleRightSidebar: (payload) => dispatch(ITR_toggleRightSidebar(payload)),
  };
}

export default itrJounrneySlice.reducer;
